<div class="profile-phone-list">

    @if (phones.length > 0) {
    @for (phone of phones; track $index) {
    <div class="profile-phone-list-item" [class.profile-phone-list-item--label]="phone.isAlertReceiver">

        <div class="profile-phone-list-item-option">
            {{ (phoneTypesText.get(phone.type) ?? '') | translate }}
        </div>

        <div class="profile-phone-list-item-value" [title]="phone.number.phoneNumber">
            {{phone.number.phoneNumber}}
        </div>

        @if (phone.isAlertReceiver) {
        <div class="profile-phone-list-item-label" [title]="'PHONES_LIST.TITLES.USED_FOR_ALERTS' | translate">

            <div class="profile-phone-list-item-label-text">
                {{ 'PHONES_LIST.TITLES.USED_FOR_ALERTS' | translate }}
            </div>

        </div>
        }

    </div>
    }
    } @else {
    <div class="profile-phone-list-empty">
        {{ 'PHONES_LIST.TITLES.EMPTY' | translate }}
    </div>
    }

</div>